<template>
  <div class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Linha 1: Links legais numa linha -->
        <div class="footer-row legal-links-row">
          <router-link class="clean-link" active-class="active" exact :to="{ name: 'Contact' }">{{ $t("header.contacto") }}</router-link>
          <router-link class="clean-link" active-class="active" exact :to="{ name: 'StaticInfos', params: { slug: 'legal' } }">{{ $t("legalInformation") }}</router-link>
          <router-link class="clean-link" active-class="active" exact :to="{ name: 'StaticInfos', params: { slug: 'qualidade' } }">{{ $t("qualityPolicy") }}</router-link>
          <router-link class="clean-link" active-class="active" exact :to="{ name: 'StaticInfos', params: { slug: 'privacy' } }">{{ $t("privacy") }}</router-link>
          <router-link class="clean-link" active-class="active" exact :to="{ name: 'StaticInfos', params: { slug: 'cookies' } }">{{ $t("cookies") }}</router-link>
        </div>

        <!-- Linha 2: Redes sociais numa linha -->
        <div class="footer-row social-links-row">
          <a v-if="getSettings && getSettings.facebook" :href="getSettings.facebook" class="clean-link" target="_blank">
            <b-icon class="icons-style" icon="facebook"></b-icon>
          </a>
          <a v-if="getSettings && getSettings.instagram" :href="getSettings.instagram" class="clean-link" target="_blank">
            <b-icon class="icons-style" icon="instagram"></b-icon>
          </a>
        </div>

        <!-- Linha 3: Email e telefone numa linha -->
        <div class="footer-row contact-row">
          <a v-if="getSettings && getSettings.email" class="clean-link" :href="`mailto:${getSettings.email}`">
            {{ getSettings.email }}
          </a>
          <a v-if="getSettings && getSettings.phone" class="clean-link" :href="`tel:${getSettings.phone}`">
            {{ getSettings.phone }}
          </a>
        </div>

        <!-- Linha 4: Powered By -->
        <div class="footer-row powered-by-row">
          <a href="https://www.adarme.pt/" class="clean-link poweredBy" target="_blank">POWERED BY © ADARME.PT</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Newsletter from '@/components/Newsletter.vue';
import { mapActions, mapState } from "vuex";

export default {
  components: {
    // Newsletter
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapState("settings", ["settingsOutput"]),
    getSettings() {
      return this.settingsOutput && this.settingsOutput.data
        ? this.settingsOutput.data
        : null;
    },
    // settingsStored: function(){
    //   return JSON.parse(localStorage.settings);
    // },
  },
  methods: {
    ...mapActions("settings", ["getList"]),
  },
};
</script>

<style scoped>
.footer {
  background-color: var(--secondary-color);
  padding: 3rem 0;
  min-height: 100%;
}

.footer-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  min-height: 100%;
}

.footer-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.clean-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  transition: opacity 0.3s;
}

.clean-link:hover {
  opacity: 0.8;
}

.legal-links-row {
  gap: 1.5rem;
}

.social-links-row {
  gap: 1rem;
}

.contact-row {
  gap: 1.5rem;
}

.powered-by-row {
  margin-top: 0.5rem;
}

.icons-style {
  width: 50px;
  height: 50px;
  color: white;
}

.poweredBy {
  font-size: 12px !important;
}

.text-bold {
  font-weight: bold;
}

/* Responsividade para tablets */
@media only screen and (max-width: 991px) {
  .footer-content {
    gap: 1.25rem;
  }

  .footer-row {
    gap: 1.25rem;
  }

  .legal-links-row {
    gap: 1rem;
  }

  .clean-link {
    font-size: 13px;
  }
}

/* Responsividade para mobile */
@media only screen and (max-width: 767px) {
  .footer {
    padding: 2rem 0;
  }

  .footer-content {
    gap: 1rem;
  }

  .footer-row {
    gap: 1rem;
    flex-wrap: wrap;
  }

  .legal-links-row {
    gap: 0.75rem;
    flex-direction: column;
  }

  .contact-row {
    flex-direction: column;
    gap: 0.5rem;
  }

  .clean-link {
    font-size: 12px;
  }

  .icons-style {
    width: 40px;
    height: 40px;
  }

  .poweredBy {
    font-size: 11px !important;
  }
}

/* Responsividade para mobile pequeno */
@media only screen and (max-width: 575px) {
  .footer {
    padding: 1.5rem 0;
  }

  .footer-content {
    gap: 0.75rem;
  }

  .legal-links-row {
    gap: 0.5rem;
  }

  .clean-link {
    font-size: 11px;
  }

  .icons-style {
    width: 35px;
    height: 35px;
  }
}
</style>